import report from './report/fr';

const i18n = {
  fr: {
    report: report,
    dimmer: {
      computing: "Calculs en cours...",
      generate_pdf: "Génération de votre rapport en cours..."
    },
    select: {
      current_heating_system: {
        placeholder: "Sélectionnez votre système de chauffage actuel",
      },
      current_hot_water_system: {
        placeholder: "Sélectionnez votre système de production d’eau chaude actuel",
      },
      considered_heating_system: {
        placeholder: "Sélectionnez le système de chauffage que vous envisagez",
      },
      considered_hot_water_system: {
        placeholder: "Sélectionnez le système de production d’eau chaude que vous envisagez",
        none: "Aucune",
      },
      solar_system: {
        empty: "Non, merci.",
      },
    },
    nb_errors: function(nbErrors) {
      return (nbErrors == 1)
        ? nbErrors + " erreur"
        : nbErrors + " erreurs";
    },
    tooltip: {
      energy_price: "Le coût proposé pour chaque énergie correspond à la moyenne de l'évolution du " +
        "<a href=\"http://www.infoenergie69-grandlyon.org/wp-content/uploads/sites/68/2018/07/quelle-energie-pour-mon-chauffage_fb_20180522.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">prix de cette énergie</a> " +
        "sur les trois dernières années.",
    },
    datas: {
      energy_types: {
        oil           : "Fioul",
        gaz           : "Gaz naturel",
        gaz_b1        : "Gaz naturel B1",
        propane       : "Propane",
        electricity   : "Electricité",
        bulk_granules : "Granulés en vrac",
        bag_granules  : "Granulés en sac",
        wood          : "Bois",
        shredded_wood : "Bois déchiqueté",
      },
      heating_systems: {
        standard_oil: {
          long  : "Fioul standard",
          short : "Fioul standard",
        },
        condensation_oil: {
          long  : "Fioul condensation",
          short : "Fioul condensation",
        },
        standard_gaz: {
          long  : "Gaz standard",
          short : "Gaz standard",
        },
        condensation_gaz: {
          long  : "Gaz condensation",
          short : "Gaz condensation",
        },
        standard_propane: {
          long  : "Propane standard",
          short : "Propane standard",
        },
        condensation_propane: {
          long  : "Propane condensation",
          short : "Propane condensation",
        },
        electric: {
          long  : "Chauffage électrique",
          short : "Chauffage électrique",
        },
        pac_air_air: {
          long  : "Pompe à chaleur air/air",
          short : "PAC air/air",
        },
        pac_air_water: {
          long  : "Pompe à chaleur air/eau",
          short : "PAC air/eau",
        },
        pac_geothermal_bt: {
          long  : "Pompe à chaleur géothermale basse température",
          short : "PAC géothermale BT",
        },
        pac_geothermal_tbt: {
          long  : "Pompe à chaleur géothermale très basse température",
          short : "PAC géothermale TBT",
        },
        pac_heat_recup: {
          long  : "Pompe à chaleur valorisant une chaleur perdue",
          short : "PAC / ch. perdue",
        },
        wood_furnace: {
          long  : "Chaudière à bûches",
          short : "Chaudière à bûches",
        },
        recent_wooden_stove: {
          long  : "Poêle bûche récent",
          short : "Poêle bûche récent",
        },
        granules_furnace: {
          long  : "Chaudière à granulés",
          short : "Chaudière à granulés",
        },
        shredded_wood_furnace: {
          long  : "Chaudière à bois déchiqueté",
          short : "Chaud. bois déchiqueté",
        },
        granules_stove: {
          long  : "Poêle à granulés",
          short : "Poêle à granulés",
        },
      },
      hot_water_systems: {
        none: {
          long  : "Aucune",
          short : "Aucune",
        },
        same: {
          long  : "Même appareil que pour le chauffage",
          short : "Idem chauffage",
        },
        standard_oil: {
          long  : "Fioul standard",
          short : "Fioul standard",
        },
        condensation_oil: {
          long  : "Fioul condensation",
          short : "Fioul condensation",
        },
        standard_gaz: {
          long  : "Gaz standard",
          short : "Gaz standard",
        },
        condensation_gaz: {
          long  : "Gaz condensation",
          short : "Gaz condensation",
        },
        standard_propane: {
          long  : "Propane standard",
          short : "Propane standard",
        },
        condensation_propane: {
          long  : "Propane condensation",
          short : "Propane condensation",
        },
        electric: {
          long  : "Chauffage électrique",
          short : "Chauffage électrique",
        },
        pac_air_air: {
          long  : "Pompe à chaleur air/air",
          short : "PAC air/air",
        },
        pac_air_water: {
          long  : "Pompe à chaleur air/eau",
          short : "PAC air/eau",
        },
        pac_geothermal_bt: {
          long  : "Pompe à chaleur géothermale basse température",
          short : "PAC géothermale BT",
        },
        pac_geothermal_tbt: {
          long  : "Pompe à chaleur géothermale très basse température",
          short : "PAC géothermale TBT",
        },
        pac_heat_recup: {
          long  : "Pompe à chaleur valorisant une chaleur perdue",
          short : "PAC / ch. perdue",
        },
        wood_furnace: {
          long  : "Chaudière à bûches",
          short : "Chaudière à bûches",
        },
        recent_wooden_stove: {
          long  : "Poêle bûche récent",
          short : "Poêle bûche récent",
        },
        granules_furnace: {
          long  : "Chaudière à granulés",
          short : "Chaudière à granulés",
        },
        shredded_wood_furnace: {
          long  : "Chaudière à bois déchiqueté",
          short : "Chaudière à bois déchiqueté",
        },
        granules_stove: {
          long  : "Poêle à granulés",
          short : "Poêle à granulés",
        },
        hot_water_tank: {
          long  : "Cumulus électrique",
          short : "Cumulus électrique",
        },
        thermo: {
          long  : "Chauffe-eau thermodynamique",
          short : "Chauffe-eau thermo.",
        },
      },
      solar_systems: {
        cesi : {
          long  : "Chauffe-eau solaire individuel",
          short : "CESI",
        },
        ssc : {
          long  : "Système solaire combiné",
          short : "SSC",
        },
      },
      energy_vectors: {
        oil_kg: {
          label : "Fioul acheté au kg",
          units : "kg de fioul",
        },
        oil_l: {
          label : "Fioul acheté au litre",
          units : "L de fioul",
        },
        propane_kg: {
          label : "Propane acheté au kg",
          units : "kg de propane",
        },
        propane_m3: {
          label : "Propane acheté au m3",
          units : "m3 de propane",
        },
        propane_bottles: {
          label : "Propane acheté en bouteilles de 13kg",
          units : "Bouteille(s) (13kg) de propane",
        },
        natural_gaz_kwh: {
          label : "Gaz Naturel au kWh",
          units : "kWh",
        },
        electricity_kwh: {
          label : "Électricité",
          units : "kWh",
        },
        wooden_stones: {
          label : "Bûche",
          units : "Stère(s) de bois",
        },
        granules_t: {
          label : "Granulés de bois à la tonne",
          units : "tonne(s)",
        },
        shredded_wood_t: {
          label : "Bois déchiqueté à la tonne",
          units : "tonne(s)",
        },
        shredded_wood_map: {
          label : "Bois déchiqueté au MAP",
          units : "MAP",
        },
        shredded_wood_kwh: {
          label : "Bois déchiqueté au kWh",
          units : "kWh",
        },
      },
      building_years: {
        before_1948       : "Bâti traditionnel < 1948",
        before_1975       : "Avant 1975",
        between_1975_1982 : "entre 1975 et 1982",
        between_1983_1988 : "entre 1983 et 1988",
        between_1989_2000 : "entre 1989 et 2000",
        between_2001_2005 : "entre 2001 et 2005",
        between_2006_2012 : "entre 2006 et 2012",
        after             : "Après 2012",
        bbc               : "Rénovation niveau basse consommation (BBC)",
        passive           : "Bâtiment passif",
      },
      units: {
        kwh_by_years  : "kWh/an",
      },
    },
    validations: {
      cant_be_blank         : "Veuillez saisir une valeur.",
      not_numeric           : "Veuillez saisir une valeur numérique.",
      not_a_positive_number : "Veuillez saisir un nombre positif.",
      not_greater_than_zero : "Veuillez saisir un nombre supérieur à 0.",
      no_option_selected    : "Veuillez sélectionner une option.",
      cant_be_blank_zero_for_no_needs : "Veuillez saisir une valeur.<br />0 si aucun besoin.",
      living_area: {
        overflow: "La valeur de la suface habitable doit être comprise entre 0 et 10000 m2.",
      },
      inhabitants: {
        overflow: "Le nombre d'habitant(s) doit être comprit entre 1 et 10.",
      },
      invoices: {
        all_invoices_must_be_numeric: "Le montant de vos factures doivent toutes être des valeurs numériques."
      },
      heating_efficiency: {
        overflow: "La valeur du rendement du système de chauffage, ou COP, doit être comprise entre 0 et 500.",
      },
      hot_water_efficiency: {
        overflow: "La valeur du rendement du système d'eau chaude doit être comprise entre 0 et 500.",
      },
      heating_energy_price: {
        overflow: "Le prix de l'énergie de chauffage doit être compris entre 0 et 100.",
      },
      hot_water_energy_price: {
        overflow: "Le prix de l'énergie d'eau chaude doit être compris entre 0 et 100.",
      },
      solar_panel_surface: {
        min: "La surface de votre installation solaire thermique doit être supérieure à zéro."
      },
    },
    wizard: {
      next: "Suivant",
      new_solution: "Saisir une autre solution de chauffage",
    },
    conclusion: {
      no_enr                    : "Tiens ! Vous n'avez intégré aucune solution basée majoritairement sur les énergies renouvelables dans vos comparaisons ?",
      enr_more_expensive        : "Le coût global des solutions à majorité renouvelable n’est pas le plus avantageux. D’autres éléments, comme le bilan environnemental, peuvent guider le choix.",
      enr_little_more_expensive : "Au moins une solution à énergies renouvelables est quasiment compétitive avec les solutions à énergies fossiles ou électriques",
      enr_little_cheaper        : "Au moins une solution à énergies renouvelables est légèrement moins onéreuse que les solutions à énergies fossiles ou électriques",
      enr_cheaper               : "Au moins une solution à énergies renouvelables est plus avantageuse économiquement que les solutions à énergies fossiles ou électriques",
      only_enr                  : "Toutes vos solutions sont à 100% ou en majorité basées sur les énergies renouvelables. Pour trouver le système le plus adapté à votre cas, n'hésitez pas à contacter votre Espace info->énergie"
    },
    charts: {
      label: {
        ecs   : "ECS",
        solar : "Solaire",
      },
      period_total_cost: {
        yAxis: {
          title: "Coût Total (€)",
        },
        tooltip: {
          devise: '€',
          total: "Total",
        },
        series: {
          solar_saving    : "Production solaire",
          energy_cost     : "Coût de l'énergie",
          investment      : "Investissement",
          maintenance     : "Entretien",
          xAxis: {
            non_enr: "Solution non EnR",
            mostly_non_enr: "Solution majoritairement non EnR",
            mostly_enr: "Solution majoritairement EnR",
            enr: "Solution EnR",
          },
        },
        ref_text: "* EnR: Énergie Renouvelable - ECS: Eau Chaude Sanitaire",
      },
      period_cost_evolution: {
        yAxis: {
          title: "Coût Cumulé (€)",
        },
        tooltip: {
          devise: '€',
        },
        ref_text: "* ECS: Eau Chaude Sanitaire",
      },
      environmental_impact: {
        primary_energy : {
          title: "Energie primaire",
          tooltip: {
            unit: "kWhep",
          },
        },
        greenhouse_gaz : {
          title: "Gaz à effet de serre",
          tooltip: {
            unit: "kgCO2eq/an",
          },
        },
      },
      energies_yearly_price_variations: {
        yAxis: {
          title: "Prix (c€ TTC/kWh)",
        },
        tooltip: {
          devise: 'c€ TTC/kWh',
        },
      },
    },
  },
};

export default i18n;



// WEBPACK FOOTER //
// ./assets/javascripts/i18n/fr.js